import { render } from "./bbmessageCenter.vue?vue&type=template&id=eba0e494"
import script from "./bbmessageCenter.vue?vue&type=script&lang=js"
export * from "./bbmessageCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__